import React, { useEffect, useState } from 'react';
import "./RecordsTable.scss"

import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import { setRecordsAction } from '../../../store/recordsTableReducer';

import { createWeekColumns, createTimeSlots } from '../../../helpers/table';
import { distributeRecordsByColumns } from '../../../helpers/record';

import Slots from '../Slots/Slots';
import Column from '../Column/Column';

const RecordsTable = () => {
	const dispatch = useDispatch()
	const records = useSelector(state => state.recordsTable.records)
	const period = useSelector(state => state.recordsTable.period)
	const clinic = useSelector(state => state.recordsTable.clinic)
	
	const slots = createTimeSlots()
	const [columns, setColumns] = useState([])
	const [recordsByColumns, setRecordsByColumns] = useState({})

	useEffect(() => {
		setColumns(createWeekColumns(period))
	}, [period])

	useEffect(() => {
		setRecordsByColumns(distributeRecordsByColumns(records))
	}, [records])

	useEffect(() => {
		if(clinic && period) fetchRecords(clinic, period)
		let timerId = setInterval(() => {
			initFetchUpdate(clinic, period)
		}, 60 * 1000);
		return ()=>{clearInterval(timerId);};
	}, [clinic, period])

	const initFetchUpdate = (clinicID, periodValue) => {
		if(clinicID && periodValue) fetchRecords(clinicID, periodValue)
	}

	const [fetchRecords] = useFetching(async (clinic, period) => {
		const response = await PostService.getRecordsByPeriod(clinic, period)
		if (response.data.success && response.data.result !== false) {
			dispatch(setRecordsAction(response.data.result))
		}
	})

	return (
		<div className="records-table">
			<div className="app-container">
				<div className="records-table__inner">
					<Slots slots={slots} type='left'/>
					{columns.map((column, index) => {
						let columnRecords = recordsByColumns[column.date]
						return(
							<Column
								element={column}
								slots={slots}
								records={columnRecords ? columnRecords : []}
								first={index === 0}
								key={column.date}/>
						)
					})}
					<Slots slots={slots} type='right'/>
				</div>
			</div>
		</div>
	);
};

export default RecordsTable;
